// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CamerasTopology.css — topología de cámaras (árbol por capas).
   Tokens del tema, sin colores en duro salvo los tonos semánticos. */

.ct-page {
  padding: 18px 22px 32px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-height: 100%;
  background: var(--bg-body);
  color: var(--text-primary);
}

.ct-kpis {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.ct-kpi {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 118px;
  padding: 10px 14px;
  border-radius: var(--radius-md, 10px);
  background: var(--bg-surface);
  border: 1px solid var(--border);
}

.ct-kpi-value {
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
}

.ct-kpi-label {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-muted);
}

.ct-kpi--accent .ct-kpi-value { color: var(--accent-l); }
.ct-kpi--on .ct-kpi-value { color: var(--success, #22c55e); }
.ct-kpi--warn .ct-kpi-value { color: var(--warn, #f59e0b); }
.ct-kpi--off .ct-kpi-value { color: var(--danger, #ef4444); }
.ct-kpi--muted .ct-kpi-value { color: var(--text-secondary); }

.ct-forest {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.ct-branch {
  position: relative;
  border-left: 3px solid var(--accent);
  padding: 4px 0 4px 16px;
}

.ct-branch--orphan {
  border-left-color: var(--warn, #f59e0b);
}

.ct-branch-head {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.ct-parent {
  font-size: 0.72rem;
  color: var(--text-muted);
}

.ct-node {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border);
  background: var(--bg-surface);
  color: var(--text-primary);
  text-decoration: none;
}

.ct-node--recorder {
  min-width: 280px;
}

.ct-node--orphan {
  border-color: rgba(245, 158, 11, 0.5);
}

.ct-node-title {
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--text-primary);
  text-decoration: none;
}

.ct-node-title:hover {
  color: var(--accent-l);
}

.ct-node-meta {
  font-size: 0.72rem;
  color: var(--text-muted);
}

.ct-cameras {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding-left: 18px;
  position: relative;
}

/* La línea vertical que une el grabador con sus cámaras. */
.ct-cameras::before {
  content: '';
  position: absolute;
  left: 4px;
  top: -6px;
  bottom: 50%;
  border-left: 1px dashed var(--border);
}

.ct-node--camera {
  font-size: 0.78rem;
  padding: 6px 10px;
  gap: 6px;
  background: var(--bg-card);
}

.ct-node--camera:hover {
  border-color: var(--accent);
}

.ct-node--alert {
  border-color: rgba(239, 68, 68, 0.55);
}

.ct-camera-name {
  font-weight: 600;
  max-width: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ct-camera-channel,
.ct-camera-ip {
  font-size: 0.68rem;
  color: var(--text-muted);
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 1px 7px;
}

.ct-no-cameras {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.76rem;
  color: var(--warn, #f59e0b);
}

.ct-empty {
  margin: 40px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: var(--text-secondary);
}

@media (max-width: 720px) {
  .ct-page { padding: 12px; }
  .ct-node--recorder { min-width: 0; width: 100%; }
  .ct-cameras { padding-left: 10px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/CamerasTopology.css"],"names":[],"mappings":"AAAA;qEACqE;;AAErE;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA,gCAAgC,sBAAsB,EAAE;AACxD,4BAA4B,8BAA8B,EAAE;AAC5D,8BAA8B,2BAA2B,EAAE;AAC3D,6BAA6B,6BAA6B,EAAE;AAC5D,+BAA+B,4BAA4B,EAAE;;AAE7D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,2DAA2D;AAC3D;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,wBAAwB;EACxB,+BAA+B;EAC/B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,WAAW,aAAa,EAAE;EAC1B,qBAAqB,YAAY,EAAE,WAAW,EAAE;EAChD,cAAc,kBAAkB,EAAE;AACpC","sourcesContent":["/* CamerasTopology.css — topología de cámaras (árbol por capas).\r\n   Tokens del tema, sin colores en duro salvo los tonos semánticos. */\r\n\r\n.ct-page {\r\n  padding: 18px 22px 32px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 14px;\r\n  min-height: 100%;\r\n  background: var(--bg-body);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.ct-kpis {\r\n  display: flex;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.ct-kpi {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n  min-width: 118px;\r\n  padding: 10px 14px;\r\n  border-radius: var(--radius-md, 10px);\r\n  background: var(--bg-surface);\r\n  border: 1px solid var(--border);\r\n}\r\n\r\n.ct-kpi-value {\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n}\r\n\r\n.ct-kpi-label {\r\n  font-size: 0.72rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.ct-kpi--accent .ct-kpi-value { color: var(--accent-l); }\r\n.ct-kpi--on .ct-kpi-value { color: var(--success, #22c55e); }\r\n.ct-kpi--warn .ct-kpi-value { color: var(--warn, #f59e0b); }\r\n.ct-kpi--off .ct-kpi-value { color: var(--danger, #ef4444); }\r\n.ct-kpi--muted .ct-kpi-value { color: var(--text-secondary); }\r\n\r\n.ct-forest {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 22px;\r\n}\r\n\r\n.ct-branch {\r\n  position: relative;\r\n  border-left: 3px solid var(--accent);\r\n  padding: 4px 0 4px 16px;\r\n}\r\n\r\n.ct-branch--orphan {\r\n  border-left-color: var(--warn, #f59e0b);\r\n}\r\n\r\n.ct-branch-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.ct-parent {\r\n  font-size: 0.72rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.ct-node {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 12px;\r\n  border-radius: var(--radius-md, 10px);\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-surface);\r\n  color: var(--text-primary);\r\n  text-decoration: none;\r\n}\r\n\r\n.ct-node--recorder {\r\n  min-width: 280px;\r\n}\r\n\r\n.ct-node--orphan {\r\n  border-color: rgba(245, 158, 11, 0.5);\r\n}\r\n\r\n.ct-node-title {\r\n  font-weight: 600;\r\n  font-size: 0.9rem;\r\n  color: var(--text-primary);\r\n  text-decoration: none;\r\n}\r\n\r\n.ct-node-title:hover {\r\n  color: var(--accent-l);\r\n}\r\n\r\n.ct-node-meta {\r\n  font-size: 0.72rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.ct-cameras {\r\n  margin-top: 10px;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  padding-left: 18px;\r\n  position: relative;\r\n}\r\n\r\n/* La línea vertical que une el grabador con sus cámaras. */\r\n.ct-cameras::before {\r\n  content: '';\r\n  position: absolute;\r\n  left: 4px;\r\n  top: -6px;\r\n  bottom: 50%;\r\n  border-left: 1px dashed var(--border);\r\n}\r\n\r\n.ct-node--camera {\r\n  font-size: 0.78rem;\r\n  padding: 6px 10px;\r\n  gap: 6px;\r\n  background: var(--bg-card);\r\n}\r\n\r\n.ct-node--camera:hover {\r\n  border-color: var(--accent);\r\n}\r\n\r\n.ct-node--alert {\r\n  border-color: rgba(239, 68, 68, 0.55);\r\n}\r\n\r\n.ct-camera-name {\r\n  font-weight: 600;\r\n  max-width: 190px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.ct-camera-channel,\r\n.ct-camera-ip {\r\n  font-size: 0.68rem;\r\n  color: var(--text-muted);\r\n  border: 1px solid var(--border);\r\n  border-radius: 999px;\r\n  padding: 1px 7px;\r\n}\r\n\r\n.ct-no-cameras {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  font-size: 0.76rem;\r\n  color: var(--warn, #f59e0b);\r\n}\r\n\r\n.ct-empty {\r\n  margin: 40px auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 10px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n@media (max-width: 720px) {\r\n  .ct-page { padding: 12px; }\r\n  .ct-node--recorder { min-width: 0; width: 100%; }\r\n  .ct-cameras { padding-left: 10px; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
